import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'common/components/elements/icons';
import Image from 'common/components/modules/image';
import PaymentMethodImageCard from '../../../payment-method-image-card';
import PaymentMethodImagesStack from '../../../payment-method-images-stack'

const MethodTypeItem = ({
   title,
   isShowMoreLessItem,
   isShowMore,
   onClick,
   isParentItem,
   iconName,
   imageSrc,
   isNextApp = false,
   hideBottomBorder,
   methodType,
   isCryptoCurrency,
   soredMethodsList,
   primaryColor,
}) => {


   return (
      <div
         className={ classNames({
            'w-full flex items-center justify-between gap-3 px-[14px] py-2 relative': true,
            'cursor-pointer hover:bg-hover dark:hover:bg-hover-dark': isShowMoreLessItem,
         }) }
         role='presentation'
         onClick={ onClick }
      >
         <div
            className='w-full flex items-center gap-3'
         >
            {
               isParentItem ? (
                  <div
                     className='w-10 h-10 shrink-0 flex items-center justify-center rounded-full bg-panel dark:bg-panel-dark border border-divider dark:border-divider-dark'
                  >
                     {
                        iconName && (
                           <Icon
                              name={ iconName }
                              // color='action'
                              // darkColor='action-dark'
                              size='2xl'
                              primaryColor={ primaryColor }
                           />
                        )
                     }
                     {
                        imageSrc && (
                           <Image
                              src={ imageSrc }
                              className='w-6 h-6'
                              alt='Crypto'
                              isNextApp={ isNextApp }
                           />
                        )
                     }
                  </div>
               ) : (
                  <PaymentMethodImageCard
                     cardWidth={ isCryptoCurrency ? 32 : 68 }
                     methodType={ methodType }
                     wrapperClassName='h-8 !p-1 !rounded-[4px]'
                     isCryptoCurrency={ isCryptoCurrency }
                     isHideHoverEffect
                     isNextApp={ isNextApp }
                  />
               )
            }
            <span
               dangerouslySetInnerHTML={ { __html: title } }
               className='text-major dark:text-major-dark leading-[18px] font-medium break-normal overflow-wrap-anywhere'
            />
         </div>
         {
            isShowMoreLessItem && (
               <div
                  className='flex items-center gap-3'
               >
                  {
                     soredMethodsList && soredMethodsList?.length > 0 && (
                        <PaymentMethodImagesStack
                           soredMethodsList={ soredMethodsList }
                           isCryptoCurrency={ isCryptoCurrency }
                           isNextApp={ isNextApp }
                        />
                     )
                  }
                  <Icon
                     name={ isShowMore ? 'arrow-up' : 'arrow-down' }
                     color='secondary'
                     darkColor='secondary-dark'
                     size='xl'
                  />
               </div>
            )
         }
         {
            !hideBottomBorder && (
               <div
                  className='absolute bottom-0 right-0 left-[66px] h-[1px] bg-divider dark:bg-divider-dark'
               />
            )
         }
      </div>
   )
}

MethodTypeItem.propTypes = {
   title: PropTypes.string,
   isShowMoreLessItem: PropTypes.bool,
   isShowMore: PropTypes.bool,
   onClick: PropTypes.func,
   isParentItem: PropTypes.bool,
   iconName: PropTypes.string,
   imageSrc: PropTypes.string,
   isNextApp: PropTypes.bool,
   hideBottomBorder: PropTypes.bool,
   methodType: PropTypes.string,
   isCryptoCurrency: PropTypes.bool,
   soredMethodsList: PropTypes.array,
   primaryColor: PropTypes.string,
}

export default MethodTypeItem;
